module.exports = __webpack_public_path__ + "img/icon-null.f2367631.png";